/* Wattle & Vale — cart drawer helpers
   - +/- knoppen in de drawer
   - "View cart" en andere links naar /cart openen de drawer
   - Na élke "Add to cart" (productpagina, quick add, sticky balk, apps) opent de drawer — nooit de winkelwagenpagina */
(function () {
  if (window.__wvCartDrawerInit) return;
  window.__wvCartDrawerInit = true;

  function getDrawer() {
    var drawer = document.getElementById('cart-drawer');
    return drawer && typeof drawer.show === 'function' ? drawer : null;
  }

  function closeOtherDrawers(drawer) {
    document.querySelectorAll('quick-buy-drawer[open], cart-notification-drawer[open]').forEach(function (el) {
      if (el !== drawer && typeof el.hide === 'function') el.hide();
    });
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    closeOtherDrawers(drawer);
    if (!drawer.hasAttribute('open')) drawer.show();
  }

  function markLoading(el) {
    var row = el && el.closest('.wv-cd-item');
    if (row) row.classList.add('is-loading');
  }

  function isCartLink(link) {
    try {
      var url = new URL(link.getAttribute('href'), location.origin);
      return url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(url.pathname);
    } catch (e) {
      return false;
    }
  }

  /* Links naar /cart → drawer (capture-fase: vóór de pagina-overgang van het thema) */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.closest('.wv-cd') || link.hasAttribute('aria-controls')) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    if (!isCartLink(link) || !getDrawer()) return;
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') return;
    event.preventDefault();
    openDrawer();
  }, true);

  /* Product toegevoegd via het thema (ook quick add): drawer openen i.p.v. het "Added to your cart"-pop-upje */
  document.addEventListener('variant:add', function () {
    setTimeout(openDrawer, 0);
  }, true);

  /* +/- knoppen in de drawer */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.wv-cd [data-wv-qty]');
    if (button) {
      var input = button.parentElement.querySelector('input[data-line-key]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(button.getAttribute('data-wv-qty'), 10);
      var max = parseInt(input.getAttribute('max'), 10);
      if (next < 1 || (max && next > max)) return;
      input.value = next;
      markLoading(button);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var remove = event.target.closest('.wv-cd .wv-cd-item__remove');
    if (remove) markLoading(remove);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('.wv-cd .wv-cd-qty__input')) markLoading(event.target);
  }, true);

  /* Toevoegingen buiten het thema om (sticky balk, bundel-apps): drawer verversen en openen */
  var originalFetch = window.fetch;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function hasSections(body) {
    try {
      if (!body) return false;
      if (typeof body === 'string') return body.indexOf('sections') !== -1;
      if (body instanceof FormData || body instanceof URLSearchParams) return body.has('sections');
    } catch (e) {}
    return false;
  }

  function syncDrawer(open) {
    originalFetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sections: ['cart-drawer'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        if (open) openDrawer();
      })
      .catch(function () {});
  }

  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var body = options && options.body;
    var request = originalFetch.apply(this, arguments);
    var match = url.match(/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/);
    if (match && !hasSections(body)) {
      request.then(function (r) { if (r.ok) syncDrawer(match[1] === 'add'); }).catch(function () {});
    }
    return request;
  };
})();